export default {
    new:                    1,
    riskAssessmentFailed:   14,
    completed:              18,
    quoteRequired:          22
};